import { getSystemNameIsSpecial } from "../../../share/util/resourceMap";

/**
 * 特殊機能表示に対応するためDTC,制御作動履歴,キャンセルコード,データモニタ,アクティブテストの計測データ一覧に表示するシステム名を取得する
 * 主に言語切り替え時に使用
 * @param {object} root 呼び出し元
 * @param {string} itemKey 機能タブ名
 * @param {object[]} diagCodeMeasuresData DTC計測データ一覧
 * @param {object[]} vchMeasuresData 制御作動履歴計測データ一覧
 * @param {object[]} cncMeasuresData キャンセルコード計測データ一覧
 * @param {object[]} indDmMeasuresData データモニタ計測データ一覧
 * @param {object[]} atMeasuresData アクティブテスト計測データ一覧
 * @returns {void}
 */
export const setMeasuresDisplaySystemName = (root, itemKey, diagCodeMeasuresData, vchMeasuresData, cncMeasuresData, indDmMeasuresData, atMeasuresData) => {
  let targetData = [];
  let funcName = '';
  switch (itemKey) {
    case 'diagCode':
      targetData = diagCodeMeasuresData;
      funcName = 'individualDtc';
      break;
    case 'controlHistory':
      targetData = vchMeasuresData;
      funcName = 'controlHistory';
      break;
    case 'cancelCode':
      targetData = cncMeasuresData;
      funcName = 'cancelCode';
      break;
    case 'dataMonitor':
      targetData = indDmMeasuresData;
      funcName = 'dataMonitor';
      break;
    case 'activeTest':
      targetData = atMeasuresData;
      funcName = 'activeTest';
      break;
    default:
      // 処理を行わず終了
      return;
  }
  targetData.forEach((data) => {
    data.displaySystemName = getSystemNameIsSpecial(root, funcName, data.system, data.isSpecial || data.is_special);
  });
};